module.exports = __webpack_public_path__ + "static/ICONIAMQS-03-a2e241e4f227756eb0fce2138e04c0f6.png";